import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useFormik } from 'formik'

import { brandsService } from 'services/brand.service'

import { _object } from 'utils/interfaces'

const EditBrand = () => {
  const { id } = useParams()
  const [brand, setBrand] = useState<_object>({})

  useEffect(() => {
    brandsService.getBrandsDetails(id).then((results: _object) => {
      setBrand(results)
    })
  }, [id])

  const formik: any = useFormik({
    initialValues: {
      title: brand?.title || '',
      description: brand?.description || ''
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      await brandsService.UpdateBrand(id, values)
    }
  })

  return (
    <>
      <div className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold">
          {brand?.title} <small className="block">SKU: {brand?.sku}</small>
        </h1>
      </div>
      <div className="grid grid-cols-2">
        <div className="flex flex-col gap-4">
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="product_info"
                className="mb-2 block text-sm font-medium text-gray-900"
              >
                Modal Title
              </label>
              <textarea
                id="product_info"
                name="product_info"
                rows={4}
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
                placeholder="Write your product information here"
              ></textarea>
            </div>

            <div className="mb-4">
              <label htmlFor="description" className="mb-2 block text-sm font-medium text-gray-900">
                Modal Description
              </label>
              <textarea
                id="description"
                name="description"
                rows={4}
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
                placeholder="Write your description here"
              ></textarea>
            </div>

            <button
              type="submit"
              className="rounded bg-purple-900 px-4 py-2 text-sm text-white hover:bg-blue-700"
            >
              Save Changes
            </button>
          </form>
        </div>
      </div>
    </>
  )
}

export default EditBrand
